var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"font-weight-bold caption blue-grey--text text--darken-3 mb-1 d-flex flex-wrap user-select-none",style:({ gap: '5px 10px' })},[_vm._t("label")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }